(function (root) {
  'use strict';
  var WORKER = 'https://throbbing-bird-ad14.mikesilvasilva11.workers.dev/api?q=';
  var QUOTE_PATH = '/pages/let-us-find-it';
  var facts = root.MSSVerifiedFacts || [];
  function clean(value, limit) { return String(value == null ? '' : value).trim().slice(0, limit || 250); }
  function normalize(value) { return clean(value).toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function modelRegex(model) {
    var key = normalize(model);
    return key ? new RegExp('(?:^|[^A-Z0-9./-])(' + key.split('').join('[-\\s./]*') + ')(?![A-Z0-9]|[-./][A-Z0-9])', 'i') : null;
  }
  function exactMatch(title, model) { var re = modelRegex(model); return !!(re && re.test(clean(title, 1000))); }
  function offeredModelConflict(title, model) {
    var key = normalize(model);
    if (!/^(?:R\d{1,2}I?|SPS\d{3}|HIPER(?:VR|HR|SR|V))$/.test(key)) return false;
    var text = clean(title, 1000).toUpperCase().replace(/[‐‑–—]/g, '-');
    var requested = modelRegex(model).exec(text);
    if (!requested) return true;
    var requestedAt = requested.index + requested[0].indexOf(requested[1]);
    var receivers = /\b(?:SPS[ -]?\d{3}|R[ -]?\d{1,2}I?|HIPER[ -]?(?:VR|HR|SR|V))\b/g;
    var candidate;
    while ((candidate = receivers.exec(text))) {
      if (normalize(candidate[0]) === key) continue;
      var explicitBundle = false;
      if (candidate.index < requestedAt) {
        var before = text.slice(candidate.index + candidate[0].length, requestedAt);
        var after = text.slice(requestedAt + requested[1].length);
        explicitBundle = /(?:\b(?:WITH|AND|PLUS|INCLUDES?|INCLUDING)\b|[+&])\s*(?:A\s+)?(?:TRIMBLE\s+|TOPCON\s+)?$/.test(before) && /^(?:\s+(?:GNSS|GPS|RTK|BASE|ROVER))*\s+RECEIVER\b/.test(after);
      } else {
        var between = text.slice(requestedAt + requested[1].length, candidate.index);
        explicitBundle = /^(?:\s+(?:GNSS|GPS|RTK|BASE|ROVER))*\s+RECEIVER\b/.test(between) && /(?:\b(?:WITH|AND|PLUS|INCLUDES?|INCLUDING)\b|[+&])\s*(?:A\s+)?(?:TRIMBLE\s+|TOPCON\s+)?$/.test(between);
      }
      if (!explicitBundle) return true;
    }
    return false;
  }
  function extractModel(query) {
    var t = clean(query).toUpperCase().replace(/[‐‑–—]/g, '-');
    var named = t.match(/^(?:TOPCON\s+)?(HIPER[ -]+(?:VR|HR|SR|V))$/);
    if (named) return named[1].replace(/[ -]+/g,' ');
    t = t.replace(/\b(\d{3,6})\s+([A-Z][A-Z0-9]{2,}(?:-[A-Z0-9]+)*)\b/g, '$1-$2');
    t = t.replace(/\b([A-Z]{2,5})\s+(\d{3,6})\b/g, '$1$2');
    var tokens = t.match(/[A-Z0-9]+(?:[-./][A-Z0-9]+)*/g) || [];
    var candidates = tokens.filter(function (x) {
      return /[A-Z]/.test(x) && /\d/.test(x) && normalize(x).length >= 3 &&
        !/^\d+(?:\.\d+)?(?:V|VAC|VDC|A|MA|HZ|KHZ|MHZ|K|KB|MB|GB|IN|MM|CM|HP|KW|CH|POLE|PIN)$/i.test(x) &&
        !/^(?:RS-?232|RS-?485|DH-?485|IP\d\d|NEMA\d+)$/i.test(x);
    });
    candidates = candidates.filter(function(x, i, a) { return a.findIndex(function(y) {return normalize(y) === normalize(x);}) === i; });
    return candidates.length === 1 ? candidates[0] : '';
  }
  function accessoryForParent(title, model) {
    const text = String(title || '').trim().slice(0, 1000).toUpperCase().replace(/[‐‑–—]/g, '-');
    const key = normalize(model), tokens = text.match(/[A-Z0-9]+(?:[-./][A-Z0-9]+)*/g) || [];
    if (key.length >= 6 && tokens.some(token => {
      const candidate = normalize(token);
      return candidate !== key && candidate.length >= key.length - 1 &&
        candidate.indexOf(key.slice(0, -2)) === 0 && /[A-Z]/.test(candidate) && /\d/.test(candidate);
    })) return true;
    if (key === 'FTB1' && /\bFTB[ -]?1\s*(?:V2|PRO)\b/.test(text)) return true;
    if (/^(?:70|90)[SR]$/.test(key) && new RegExp('\\b' + key + '\\s*(?:\\+|PLUS\\b)').test(text)) return true;
    const re = modelRegex(model), match = re && re.exec(text);
    if (!match) return false;
    const modelAt = match.index + match[0].indexOf(match[1]);
    const before = text.slice(0, modelAt).replace(/\b(?:FOR\s+SALE|LIKE\s+NEW)\b/g, '');
    if (/\b(?:FOR|FITS|COMPATIBLE\s+WITH|REPLACEMENT\s+FOR|REPLACES|LIKE|LK|SIMILAR\s+TO|COMPARE\s+(?:TO|WITH)|VERSUS|VS)\b[^.!?]{0,80}$/.test(before)) return true;
    const receiver = /^(?:R\d{1,2}I?|HIPER(?:VR|HR|SR|V))$/.test(key);
    if (receiver && /\b(?:TABLETS?|DATA\s+COLLECTORS?|FIELD\s+CONTROLLERS?|SURVEY\s+CONTROLLERS?|SOFTWARE|LICENSES?)\b/.test(before)) {
      const afterModel = text.slice(modelAt + match[1].length);
      const explicitBundle = /(?:\b(?:WITH|INCLUDES?|INCLUDING|SUPPLIED\s+WITH|AND|PLUS)\b|[+&])\s*(?:A\s+)?(?:(?:TRIMBLE|TOPCON)\s+)?$/.test(before) &&
        /^(?:\s+(?:GNSS|GPS|RTK))*\s+RECEIVER\b/.test(afterModel);
      if (!explicitBundle) return true;
    }
    const meter = /^(?:8[3789]V|11[567]|17[579]|28[79]|7(?:05|07|12|14|15|17|18|19|21|24|25|26|44|45|53|54)|3(?:23|24|25|75|76)|1587|1507)$/.test(key);
    const inspection = /^FIP\d{3}[A-Z]?$/.test(key);
    const portable = /^(?:R\d{1,2}I?|HIPER(?:VR|HR|SR|V)|CB\d{3}|TSC[2357]|TDC\d{3}|ONX\d{3}|MS\d{4}[A-Z]?|DR\d{4}|FTB\d+|MAX\d{3}[A-Z]?|VLOC\dPRO|(?:70|90)[SR])$/.test(key);
    const automation = /^(?:1734|1746|1747L|1756L|1769L|5069L|6ES7|6SL|A06B|EDS\d|DM\d|PZG|C0\d|LC1D)/.test(key);
    const equipment = meter || inspection || portable || automation || facts.some(f => normalize(f.mpn) === key && f.kind !== 'cable');
    let terms = 'MANUALS?|BROCHURES?|INSTRUCTION\\s+SHEETS?';
    if (portable) terms += '|ELECTRODES?|FIBER\\s+HOLDERS?|BOARDS?|PCB|BASE\\s+EXTENSION|HEIGHT\\s+(?:MEASUREMENT|MEASURING)\\s+LEVER';
    if (equipment) terms += '|CABLES?|CORDS?|PROBES?|ADAPTERS?|BATTER(?:Y|IES)|CHARGERS?|ANTENNAS?|HARNESS(?:ES)?|MOUNTS?|CASES?|BAGS?|POUCHES?|HOLSTERS?|STRAPS?|COVERS?|LAMPS?|CHARGING\\s+(?:DOCK|STATION|CRADLE)|POWER\\s+(?:SUPPLY|PLUG|CONNECTOR)|TERMINAL\\s+PLUG|REPAIR\\s+KIT|MEMBRANE|OVERLAY|BEZEL|MOUNTING\\s+BRACKET|CUVETTES?|SAMPLE\\s+CELL|REAGENTS?|TOUCH\\s*SCREEN\\s+(?:GLASS|REPLACEMENT)|LCD\\s+(?:PANEL|REPLACEMENT)|CATV\\s+MODULE';
    if (inspection) terms += '|LENS(?:ES)?|INSPECTION\\s+TIPS?|REPLACEMENT\\s+TIPS?|CONNECTOR\\s+TIPS?';
    if (meter) terms += '|STORAGE|HANGING\\s+KIT|HANGERS?|MAGNETS?|CLIPS?|FUSES?|TEST\\s+LEADS?';
    const accessories = [...text.matchAll(new RegExp('\\b(?:' + terms + ')\\b', 'g'))];
    for (const accessory of accessories) {
      const left = text.slice(0, accessory.index), right = text.slice(accessory.index + accessory[0].length);
      const ownsModel = modelAt < accessory.index;
      if (accessory[0] === 'CABLE' && /^\s+(?:TESTER|ANALYZER|ANALYSER|LOCATOR)\b/.test(right)) continue;
      if (inspection && /^PROBES?$/.test(accessory[0]) && !/^\s+(?:TIP|HEAD|LENS|ADAPTER|REPLACEMENT)\b/.test(right)) continue;
      const omitted = /\b(?:NO|WITHOUT|EXCLUDING)\s+(?:(?:A|AN|THE|ANY)\s+)?$/.test(left) || /^\s+(?:NOT\s+INCLUDED|NOT\s+SUPPLIED)\b/.test(right);
      if (ownsModel && omitted) continue;
      if (/^\s+ONLY\b/.test(right) || /\bEMPTY\s*$/.test(left)) return true;
      const included = /(?:\b(?:WITH|INCLUDES?|INCLUDING|SUPPLIED\s+WITH)\b|\bW\s*\/)\s*[^.;]{0,100}$/.test(left);
      if (!ownsModel || !included) return true;
    }
    return false;
  }
  function conditionInfo(item) {
    var label = clean(item.condition, 100), title = clean(item.title, 1000);
    var evidence = label + ' ' + title;
    if (String(item.conditionId) === '7000' || /\b(?:for\s+parts|not\s+working|non[- ]?working|broken|faulty|no\s+power|untested|as[- ]is|repair[- ]only|exchange[- ]only|core[- ]only|send[- ]in|mail[- ]in|repair\s+service|calibration\s+service|repair\s+and\s+return|service\s+only|parts\s+only)\b/i.test(evidence)) return null;
    if (/refurbish|recondition/i.test(label)) return {group:'refurbished', label:'Refurbished'};
    if (/open\s*box|new\s*[–—-]?\s*other/i.test(label)) return {group:'open', label:'Open box / New other'};
    if (/new\s+old\s+stock|\bNOS\b/i.test(label)) return {group:'new', label:'New old stock'};
    if (/\bnew\b/i.test(label)) {
      if (/\b(?:used|refurbished|open\s*box)\b/i.test(title)) return null;
      return {group:'new', label:'New'};
    }
    if (/\bused\b|pre[- ]owned/i.test(label)) return {group:'used', label:'Used'};
    return null;
  }
  function numeric(value) {
    var raw = value && typeof value === 'object' ? value.value : value;
    if (raw === null || raw === undefined || raw === '' || typeof raw === 'boolean') return null;
    var n = Number(raw); return Number.isFinite(n) && n >= 0 ? n : null;
  }
  function estimate(item) {
    var price = numeric(item.price);
    var priceCurrency = item.price && item.price.currency;
    if (!(price > 0) || (priceCurrency && priceCurrency !== 'USD')) return null;
    return {value:Math.round(1.5 * price * 100) / 100};
  }
  function selectOffers(items, model) {
    var best = {};
    (Array.isArray(items) ? items : []).slice(0, 100).forEach(function(item) {
      if (!item || !exactMatch(item.title, model) || offeredModelConflict(item.title, model) || accessoryForParent(item.title, model)) return;
      var condition = conditionInfo(item); if (!condition) return;
      var price = estimate(item), rank = price ? price.value : Infinity;
      var previous = best[condition.group];
      if (!previous || rank < previous.rank) best[condition.group] = {item:item, condition:condition, estimate:price, rank:rank};
    });
    return ['used','new','open','refurbished'].map(function(k) {return best[k];}).filter(Boolean);
  }
  function quoteUrl(context) {
    var p = new URLSearchParams();
    ['query','brand','condition','quantity','product','variant','estimate','search','mpn','title'].forEach(function(k) {
      if (context[k] != null && clean(context[k])) p.set(k, clean(context[k]));
    });
    return QUOTE_PATH + (p.toString() ? '?' + p.toString() : '');
  }
  function matchingFacts(query) {
    var matches = facts.filter(function(f) {return exactMatch(query, f.mpn) && !accessoryForParent(query, f.mpn);});
    return matches.length === 1 ? matches[0] : null;
  }
  function el(tag, className, text) {
    var n = document.createElement(tag);
    if (className) n.className = className;
    if (text != null) n.textContent = text;
    return n;
  }
  function familyKey(evidence) {
    var input = evidence && typeof evidence === 'object' ? evidence : {title:evidence};
    var text = [input.type,input.title,input.description].filter(Boolean).join(' ').toLowerCase().replace(/[‐‑–—]/g,'-');
    var brand = String(input.brand || '').toLowerCase();
    var model = normalize(input.model || extractModel(text));
    // Identify the requested device before accessories included in a listing.
    var subject = text.split(/\b(?:compatible with|for use with|supplied with|includes|including|with)\b|\bw\s*\//)[0];
    if (/\b(?:programming|communication|usb|serial|ethernet) cable\b/.test(subject)) return 'electrical';
    if (/\b(?:fiber|fibre|connector|end.face|wireless) inspection\b|\bfiberscope\b/.test(subject) || /^FIP\d/.test(model)) return 'electrical-test';
    if (/\b(?:splicer|cleaver|fusion splicing)\b/.test(subject)) return 'fiber';
    if (/\b(?:otdr|optical power meter|optical (?:cable )?tester|spectrum analy[sz]er|cable (?:tester|analy[sz]er)|network analy[sz]er)\b/.test(subject)) return 'electrical-test';
    if (/\b(?:multimeter|calibrator|clamp meter|insulation tester|megohmmeter)\b/.test(subject)) return 'calibration';
    if (/\b(?:oscilloscope|signal generator|thermal (?:imager|camera)|infrared camera|spectrophotometer|turbidimeter|water quality|gas analy[sz]er)\b/.test(subject)) return 'test';
    if (/\b(?:hmi|panelview|operator (?:panel|interface|terminal)|touch ?screen|comfort panel)\b/.test(subject)) return 'hmi';
    if (/\b(?:power suppl(?:y|ies)|sitop)\b/.test(subject)) return 'power';
    if (/\b(?:pressure|temperature|flow|level|vibration|process) (?:transmitter|sensor|switch|probe|meter|monitor)|\b(?:panel meter|thermocouple|pressure gauge|temperature controller)\b/.test(subject)) return 'instrumentation';
    if (/\b(?:utility|cable|pipe) locator|\b(?:machine control|grade control|control box|laser receiver|rotating laser|rotary laser)\b/.test(subject)) return 'locating';
    if (/^HIPER(?:VR|HR|SR|V)$/.test(model) || /\bhiper[ -]+(?:vr|hr|sr|v)\b/.test(text)) return 'survey';
    if (/^R\d{1,2}I?$/.test(model)) return 'survey';
    if (/^(?:CB\d{3}|VLOC\dPRO|RD\d{4})$/.test(model)) return 'locating';
    if (/^(?:70|90)[SR]$/.test(model)) return 'fiber';
    if (/^(?:ONX\d{3}|MS\d{4}[A-Z]?|FTB\d+|MAX\d{3}[A-Z]?|FIP\d{3}[A-Z]?)$/.test(model)) return 'electrical-test';
    if (/^DR\d{4}$/.test(model)) return 'test';
    if (/^(?:TSC[2357]|TDC\d{3})$/.test(model)) return 'field';
    if (/^(?:2711|6AV|PFX)/.test(model)) return 'hmi';
    if (/^(?:1734|1746|1747L|1756|1769|5069|6ES|C0\d)/.test(model)) return 'plc';
    if (/^6SL/.test(model)) return 'vfd';
    if (/^(?:A06B|2198|2094|2097)/.test(model)) return 'servo';
    if (/^(?:20[ABCD]|25[AB]|ATV\d)/.test(model)) return 'vfd';
    if (/^LC1D/.test(model)) return 'breakers';
    if (/^(?:PZG|DM\d)/.test(model)) return 'vision';
    if (/^EDS\d/.test(model)) return 'networking';
    if (/^DSNU/.test(model)) return 'pneumatics';
    var rules=[
      ['survey',/\b(gnss|gps|total station|survey receiver|laser scanner)\b/],
      ['field',/\b(field controller|data collector|survey tablet)\b/],
      ['locating',/\b(locator|utility locating)\b/],
      ['servo',/\b(servo|servomotor|kinetix)\b/],
      ['vfd',/\b(vfd|inverter|powerflex|altivar|frequency drive)\b/],
      ['safety',/\b(safety|light curtain|guardmaster|emergency stop)\b/],
      ['vision',/\b(vision camera|smart camera|machine vision|photoelectric|barcode reader|code reader|in-sight|dataman)\b/],
      ['breakers',/\b(circuit breaker|contactor|overload relay|motor starter|relay)\b/],
      ['pneumatics',/\b(pneumatic|solenoid valve|valve manifold|air cylinder|air regulator|hydraulic valve)\b/],
      ['networking',/\b(ethernet switch|network switch|industrial router|scalance|serial server|media converter|protocol converter|network gateway)\b/],
      ['plc',/\b(plc|guardlogix|controllogix|compactlogix|simatic|slc|i\/o|logic controller|input module|output module|cpu module)\b/],
      ['electrical-test',/\b(otdr|optical|rf analy[sz]er)\b/],
      ['test',/\b(analy[sz]er|tester|meter|measurement|data acquisition)\b/],
      ['instrumentation',/\b(transmitter|thermostat|process monitor)\b/],
      ['sensors',/\b(sensor|encoder|proximity switch)\b/],
      ['motion',/\b(motor|robot|actuator|gearbox|bearing)\b/],
      ['electrical',/\b(enclosure|cabinet|terminal block|connector|cable)\b/],
      ['controls',/\b(controller|processor|industrial computer|industrial pc)\b/]
    ];
    var match=rules.find(function(rule){return rule[1].test(subject);});
    if (match) return match[0];
    // Broad brand families are a last resort; specific equipment always wins.
    var brands = brandFamilyRules();
    var names = brand || text;
    var brandMatch=brands.find(function(rule){return rule[1].test(names);});
    return brandMatch?brandMatch[0]:'general';
  }
  function brandFamilyRules() {
    return [
      ['electrical-test',/\b(exfo|anritsu|viavi|jdsu)\b/i],
      ['fiber',/\b(fujikura|sumitomo electric)\b/i],
      ['locating',/\b(vivax|metrotech|radiodetection)\b/i],
      ['survey',/\b(trimble|topcon|leica(?: geosystems)?|sokkia|spectra precision|novatel)\b/i],
      ['test',/\b(keysight|agilent|tektronix|national instruments|flir|hach)\b/i],
      ['calibration',/\b(fluke|megger)\b/i],
      ['networking',/\b(moxa|hirschmann|belden)\b/i],
      ['vision',/\b(cognex|datalogic)\b/i],
      ['safety',/\b(pilz)\b/i],
      ['sensors',/\b(keyence|balluff|banner(?: engineering)?|baumer|ifm|leuze|sick|turck|pepperl[+ &-]*fuchs)\b/i],
      ['instrumentation',/\b(bently nevada|dwyer|emerson|endress[+ &-]*hauser|honeywell|omega|rosemount|wika|yokogawa)\b/i],
      ['pneumatics',/\b(asco|b[üu]rkert|ckd|festo|smc|norgren|parker)\b/i],
      ['hmi',/\b(pro[ -]?face|red lion)\b/i],
      ['servo',/\b(fanuc|kollmorgen|yaskawa)\b/i],
      ['vfd',/\b(control techniques|danfoss|lenze)\b/i],
      ['motion',/\b(baldor|bosch rexroth|rexroth|kawasaki|kuka|nidec|sew[ -]?eurodrive)\b/i],
      ['electrical',/\b(altech|eaton|hammond|phoenix contact|rittal|square d|stahl|telemecanique|weidm[üu]ller)\b/i],
      ['controls',/\b(abb|advantech|allen[ -]?bradley|rockwell(?: automation)?|automation[ -]?direct|b[& ]+r|beckhoff|carlo gavazzi|delta(?: electronics)?|fuji electric|ge|hitachi|idec|mitsubishi(?: electric)?|omron|panasonic|schneider(?: electric)?|siemens|toshiba|wago)\b/i]
    ];
  }
  function familyFigure(evidence) {
    if(typeof document==='undefined')return null;
    var dataElement=document.getElementById('MSSVisualData'),strings=document.getElementById('MSSVisualStrings');
    if(!dataElement||!strings)return null;
    var data;try{data=JSON.parse(dataElement.textContent);}catch(_){return null;}
    var key=evidence && evidence.family || familyKey(evidence),url=data.assets[key]||data.assets.general;
    if(!url||!url.startsWith('https://cdn.shopify.com/'))return null;
    var figure=el('figure','mss-family-figure'),img=el('img','');
    figure.dataset.mssFamily=key;
    var category=(data.categories||[]).find(function(c){return c.key===key;});
    img.src=url+'&width=720';img.alt=(category ? category.label + ' — ' : '') + strings.dataset.alt;img.width=1536;img.height=1024;img.loading='lazy';img.decoding='async';
    img.addEventListener('error',function(){img.remove();},{once:true});
    figure.appendChild(img);figure.appendChild(el('figcaption','',strings.dataset.caption));return figure;
  }

  function renderFacts(target, record) {
    if (!target || !record) return;
    target.replaceChildren(); target.classList.add('mss-product-facts'); target.hidden = false;
    var family = familyFigure({model:record.mpn,brand:record.brand,type:record.kind,description:record.summary});
    if (family) target.appendChild(family);
    target.appendChild(el('p','mss-eyebrow','Product overview'));
    target.appendChild(el('h2','',record.brand + ' ' + record.mpn));
    target.appendChild(el('p','',record.summary));
    var list = el('dl','mss-spec-list');
    [['Brand',record.brand],['Model / MPN',record.mpn]].concat(record.fields.map(function(f) {return [f.label,f.value];})).forEach(function(pair) {
      list.appendChild(el('dt','',pair[0])); list.appendChild(el('dd','',pair[1]));
    });
    target.appendChild(list);
    target.appendChild(el('p','mss-facts-note','Manufacturer model information. Offered-unit revision, accessories, testing and warranty coverage are confirmed with your quote.'));
    var details = el('details','mss-fact-sources');
    details.appendChild(el('summary','','Technical sources · checked ' + record.verifiedOn));
    var sources = el('ul','');
    record.sources.forEach(function(s) {
      var li = el('li',''), a = el('a','mss-source-link',s.title);
      a.href = s.url; a.target = '_blank'; a.rel = 'noopener noreferrer'; li.appendChild(a); sources.appendChild(li);
    });
    details.appendChild(sources); target.appendChild(details);
  }
  function renderOffer(offer, model, query, record) {
    var card = el('article','mss-offer');
    if (!record) { var family = familyFigure({model:model,brand:query,title:offer.item.title}); if (family) card.appendChild(family); }
    card.appendChild(el('p','mss-catalog-status','Available to quote'));
    card.appendChild(el('h2','',record ? offer.condition.label : model));
    if (!record) card.appendChild(el('p','','Condition: ' + offer.condition.label));
    if (offer.estimate) {
      var price = el('p','mss-estimate');
      price.appendChild(el('span','mss-estimate-label','Estimated Price'));
      price.appendChild(document.createTextNode(new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(offer.estimate.value) + ' USD'));
      card.appendChild(price);
      card.appendChild(el('p','mss-quote-disclosure','Shipping, taxes and duties quoted separately.'));
    }
    var a = el('a','mss-quote-button','Request a Quote');
    a.href = quoteUrl({query:record ? record.mpn : model, mpn:record ? record.mpn : model, brand:record ? record.brand : '', condition:offer.condition.label, estimate:offer.estimate ? offer.estimate.value.toFixed(2) : '', search:query, title:clean(offer.item.title)});
    card.appendChild(a); return card;
  }
  async function lookup(model, fetcher, timeoutMs) {
    var controller = new AbortController();
    var timer = setTimeout(function() {controller.abort();}, timeoutMs || 12000);
    try {
      var response = await fetcher(WORKER + encodeURIComponent(model), {signal:controller.signal, credentials:'omit'});
      if (!response.ok) throw new Error('Availability lookup failed');
      var data = await response.json();
      return selectOffers(data && data.items, model);
    } finally {clearTimeout(timer);}
  }
  function nativeQuery(model) {
    return Array.from(new Set([model,model.replace(/[-./ ]+/g,' '),normalize(model)]))
      .map(function(t) {return '"' + t + '"';}).join(' OR ');
  }
  async function catalogPresence(model, fetcher, preview) {
    var query = nativeQuery(model), url = new URL('/search',root.location ? root.location.origin : 'https://www.mssautomation.com');
    url.searchParams.set('q',query); url.searchParams.set('type','product');
    url.searchParams.set('options[unavailable_products]','show'); url.searchParams.set('view','mss-native-check');
    if (/^\d+$/.test(preview || '')) url.searchParams.set('preview_theme_id',preview);
    var controller = new AbortController(), timer = setTimeout(function(){controller.abort();},10000);
    try {
      for (var page=1; page<=10; page++) {
        url.searchParams.set('page',String(page));
        var response = await fetcher(url.href,{signal:controller.signal,credentials:'same-origin'});
        if (!response.ok) return {state:'unknown'};
        var data = await response.json();
        if (data.schema !== 'mss-native-check-v1' || data.query !== query || data.performed !== true ||
            data.page !== page || !Number.isInteger(data.pages) || data.pages<0 ||
            !Number.isInteger(data.total) || !Array.isArray(data.products)) return {state:'unknown'};
        var match = data.products.find(function(p) {
          if ((p.skus || []).some(function(s){return normalize(s) === normalize(model);})) return true;
          if (!exactMatch(p.title,model)) return false;
          var re = modelRegex(model), m = re.exec(p.title), before = p.title.slice(0,m.index + m[0].indexOf(m[1]));
          return !/\b(?:for|fits|compatible\s+with|replacement\s+for|replaces)\b[^.!?]{0,80}$/i.test(before);
        });
        if (match) return {state:'present',product:match};
        if (page>=Math.max(1,data.pages)) return {state:'absent'};
      }
    } catch (_) {return {state:'unknown'};} finally {clearTimeout(timer);}
    return {state:'unknown'};
  }
  function safeInfoLink(value) {
    try {
      var u = new URL(value);
      if (u.protocol !== 'https:' || u.username || u.password) return '';
      if (/(^|\.)(ebay\.[a-z.]+|ebayimg\.com|ebaystatic\.com)$/.test(u.hostname)) return '';
      return u.href;
    } catch (_) {return '';}
  }
  function referenceLink(url, label) {
    var safe = safeInfoLink(url); if (!safe) return null;
    var a = el('a','mss-source-link',label || 'Source');
    a.href = safe; a.target = '_blank'; a.rel = 'noopener noreferrer'; return a;
  }
  function renderExternalInfo(target, product, model) {
    if (!target || !product || normalize(product.mpn) !== normalize(model) || !product.brand?.value ||
        !safeInfoLink(product.brand.sourceUrl)) return;
    target.replaceChildren(); target.hidden = false; target.classList.add('mss-product-facts');
    target.appendChild(el('p','mss-eyebrow','Product reference'));
    target.appendChild(el('h2','',clean(product.brand.value,100) + ' ' + clean(product.mpn,100)));
    var body = el('div','mss-reference-body'), copy = el('div','mss-reference-copy');
    var evidence = {model:model,brand:product.brand.value,description:[product.description?.value || ''].concat((product.specifications || []).map(function(f){return f.label + ' ' + f.value;})).join(' ')};
    var family = familyFigure(evidence);
    if (family) body.appendChild(family);
    if (product.description?.value && safeInfoLink(product.description.sourceUrl)) {
      var description = el('p','',clean(product.description.value,250) + ' ');
      description.appendChild(referenceLink(product.description.sourceUrl,product.description.sourceLabel)); copy.appendChild(description);
    }
    var list = el('dl','mss-spec-list'), fields = [{label:'Brand',value:product.brand.value,sourceUrl:product.brand.sourceUrl,sourceLabel:product.brand.sourceLabel,scope:'exact_model'},
      {label:'Model / MPN',value:product.mpn,sourceUrl:product.brand.sourceUrl,sourceLabel:product.brand.sourceLabel,scope:'exact_model'}];
    fields = fields.concat((product.specifications || []).slice(0,6)).concat((product.compatibleBrands || []).slice(0,3).map(function(c){return {label:'Documented compatibility',value:c.value,sourceUrl:c.sourceUrl,scope:c.scope};}));
    fields.forEach(function(f){
      var source = referenceLink(f.sourceUrl,f.sourceLabel); if (!source || !f.value || !f.label) return;
      list.appendChild(el('dt','',clean(f.label,70) + (f.scope === 'family' ? ' (family)' : '')));
      var value = el('dd','',clean(f.value,250) + ' '); value.appendChild(source); list.appendChild(value);
    });
    copy.appendChild(list); body.appendChild(copy); target.appendChild(body);
    if (product.aiGenerated) target.appendChild(el('p','mss-facts-note',clean(product.verification,300) || 'AI-assisted product reference. Confirm critical specifications with your quote.'));
    target.appendChild(el('p','mss-facts-note','Product reference information. Exact unit revision, accessories, condition and warranty coverage are confirmed in your quote.'));
    var container=target.closest('[data-mss-search]');
    if(container){container.dataset.mssReferenceFamily=familyKey(evidence);applyFamilyContext(container);}
  }
  function applyFamilyContext(container) {
    if(!container || !container.dataset.mssReferenceFamily) return;
    container.querySelectorAll('[data-mss-offers] .mss-family-figure, [data-mss-request-panel] .mss-family-figure').forEach(function(current){
      var replacement=familyFigure({family:container.dataset.mssReferenceFamily});
      if(replacement)current.replaceWith(replacement);
    });
  }
  function applyReferenceContext(container, model, brand) {
    if (!container || !brand) return;
    container.dataset.mssReferenceBrand = clean(brand,100);
    container.querySelectorAll('[data-mss-offers] .mss-quote-button, [data-mss-request-panel] .mss-quote-button').forEach(function(link) {
      var url = new URL(link.href,root.location.origin);
      if (url.origin !== root.location.origin || url.pathname !== QUOTE_PATH) return;
      url.searchParams.set('brand',clean(brand,100)); url.searchParams.set('mpn',model);
      link.href = url.pathname + url.search;
    });
  }
  async function enrichExternal(target, model, query) {
    if (!target || target.dataset.mssInfoLoading === 'true') return;
    target.dataset.mssInfoLoading = 'true';
    var hadFacts = target.childElementCount > 0;
    var progress = el('p','mss-search-status',target.dataset.infoLoading);
    progress.setAttribute('role','status');
    progress.setAttribute('aria-live','polite');
    target.before(progress);
    target.setAttribute('aria-busy','true');
    var controller = new AbortController(), deadline = Date.now() + 120000;
    var stopped = false, ready = false, noReference = false;
    var timer = setTimeout(function(){controller.abort();},120000);
    var slowTimer = setTimeout(function(){progress.textContent = target.dataset.infoWaiting;},15000);
    function stop() {stopped = true; controller.abort();}
    root.addEventListener('pagehide',stop,{once:true});
    function pause(ms) {
      return new Promise(function(resolve) {
        if (controller.signal.aborted) {resolve(); return;}
        var pauseTimer = setTimeout(done,ms);
        function done() {clearTimeout(pauseTimer); controller.signal.removeEventListener('abort',done); resolve();}
        controller.signal.addEventListener('abort',done,{once:true});
      });
    }
    try {
      var endpoint = WORKER.replace('/api?q=','/product-info?q=');
      var hint = clean(query,120).replace(modelRegex(model),' ').replace(/^[\s-]+|[\s-]+$/g,'');
      var url = endpoint + encodeURIComponent(model) + (hint ? '&brand=' + encodeURIComponent(hint) : '');
      for (var attempt = 0; attempt < 3 && !controller.signal.aborted && target.isConnected; attempt++) {
        var response, data, retry = false, delay = 5000;
        try {
          response = await root.fetch(url,{signal:controller.signal,credentials:'omit',cache:'no-store'});
          if (response.ok) {
            data = await response.json();
            if (data.schema !== 'mss-external-info-v1') break;
            if (data.state === 'ready') {
              if (normalize(data.product?.mpn) !== normalize(model) || !data.product?.brand?.value || !safeInfoLink(data.product.brand.sourceUrl)) break;
              if (controller.signal.aborted || !target.isConnected) break;
              renderExternalInfo(target,data.product,model);
              applyReferenceContext(target.closest('[data-mss-search]'),model,data.product.brand.value);
              ready = true; break;
            }
            if (data.state === 'no_reference') {noReference = true; break;}
            retry = response.status === 202 || data.state === 'pending';
          } else {
            retry = [408,429,500,502,503,504].includes(response.status);
          }
          if (retry) {
            var retryAfter = response.headers.get('Retry-After');
            var retryMs = /^\d+$/.test(retryAfter || '') ? Number(retryAfter) * 1000 : Date.parse(retryAfter || '') - Date.now();
            delay = Number.isFinite(retryMs) && retryMs >= 0 ? Math.max(5000,retryMs) : response.status === 429 ? 60000 : 5000;
          }
        } catch (_) {retry = !controller.signal.aborted;}
        if (!retry || attempt === 2 || controller.signal.aborted || Date.now() + delay >= deadline) break;
        await pause(delay);
      }
    } catch (_) {
    } finally {
      clearTimeout(timer); clearTimeout(slowTimer);
      root.removeEventListener('pagehide',stop);
      target.removeAttribute('aria-busy');
      delete target.dataset.mssInfoLoading;
      if (ready || hadFacts || stopped || !target.isConnected) progress.remove();
      else progress.textContent = noReference ? target.dataset.infoMissing : target.dataset.infoUnavailable;
    }
  }

  async function initSearch(container) {
    if (container.dataset.performed !== 'true') return;
    var query = clean(container.dataset.query), model = extractModel(query), record = matchingFacts(query);
    if (record) model = record.mpn;
    var factsTarget = container.querySelector('[data-mss-product-facts]');
    var nativeRows = Array.from(container.querySelectorAll('[data-mss-native-title]'));
    if (model) {
      nativeRows.forEach(function(n) {
        var relevant = exactMatch(n.dataset.mssNativeTitle, model) && !accessoryForParent(n.dataset.mssNativeTitle, model);
        var row = n.closest('li'); if (row) row.hidden = !relevant;
      });
      nativeRows = nativeRows.filter(function(n) {return !n.closest('li')?.hidden;});
      var nativeSection = container.querySelector('.mss-native-results');
      if (nativeSection) nativeSection.hidden = !nativeRows.length;
    }
    var hasExactNative = model && nativeRows.some(function(n) {return exactMatch(n.dataset.mssNativeTitle, model) && !accessoryForParent(n.dataset.mssNativeTitle, model);});
    var status = container.querySelector('[data-mss-search-status]');
    var panel = container.querySelector('[data-mss-request-panel]');
    if (hasExactNative) {
      status.textContent = 'Matching catalog products shown above. Request a quote to confirm condition and availability.';
      panel.hidden = true; return;
    }
    if (!model) {
      status.textContent = nativeRows.length ? 'Catalog matches shown above. You can also request a quote for your exact part.' : 'Enter an exact part number or request a quote with the details you have.';
      return;
    }
    status.textContent = 'Checking the catalog for ' + model + '…';
    var preview = new URLSearchParams(root.location.search).get('preview_theme_id');
    var presence = await catalogPresence(model,root.fetch.bind(root),preview);
    if (presence.state === 'present') {
      status.textContent = 'This part is in our catalog. Request a quote to confirm condition and availability.';
      var productUrl = presence.product && presence.product.url;
      if (/^\/products\/[a-z0-9-]+(?:\?|$)/i.test(productUrl || '')) {
        var catalogLink = el('a','mss-quote-button','View catalog item');
        catalogLink.href = productUrl; status.appendChild(document.createTextNode(' ')); status.appendChild(catalogLink);
      }
      return;
    }
    if (presence.state === 'unknown') {
      status.textContent = 'Request a quote and we’ll confirm this part in our catalog and sourcing network.';
      panel.hidden = false; return;
    }
    renderFacts(factsTarget,record);
    if (!record) { var fallback = familyFigure({model:model,brand:query,title:query}); if (fallback && panel) panel.prepend(fallback); }
    enrichExternal(factsTarget,model,query);
    status.textContent = 'Checking quote options for ' + model + '…';
    try {
      var offers = await lookup(model, root.fetch.bind(root), 12000);
      var target = container.querySelector('[data-mss-offers]'); target.replaceChildren();
      offers.forEach(function(o) {target.appendChild(renderOffer(o, model, query, record));});
      applyFamilyContext(container);
      applyReferenceContext(container,model,container.dataset.mssReferenceBrand);
      if (offers.length) {
        status.textContent = 'Quote options for ' + model + '. Availability will be confirmed with your quote.';
        panel.hidden = true;
      } else {
        status.textContent = 'Request a quote for ' + model + ' and we’ll check sourcing options.';
      }
    } catch (_) {
      status.textContent = 'Online availability could not be checked. Request a quote and we’ll check this part for you.';
      panel.hidden = false;
    }
  }
  function readContext(search) {
    var p = new URLSearchParams(search), query = clean(p.get('query') || p.get('q'));
    var quantity = Number(p.get('quantity') || 1);
    return {query:query, brand:clean(p.get('brand'),120), condition:clean(p.get('condition'),100), quantity:Number.isInteger(quantity) && quantity > 0 && quantity <= 100000 ? String(quantity) : '1', product:/^\d{1,30}$/.test(p.get('product') || '') ? p.get('product') : '', variant:/^\d{1,30}$/.test(p.get('variant') || '') ? p.get('variant') : '', estimate:/^\d{1,9}(?:\.\d{1,2})?$/.test(p.get('estimate') || '') ? p.get('estimate') : '', search:clean(p.get('search')), mpn:clean(p.get('mpn')),title:clean(p.get('title'))};
  }
  function prefill() {
    var context = readContext(root.location.search), form = document.querySelector('.mss-rfq-form form');
    if (!form) return;
    form.querySelectorAll('[data-mss-prefill]').forEach(function(input) {
      var key = input.dataset.mssPrefill, value = context[key];
      if (!value || (key !== 'quantity' && input.value && input.tagName !== 'SELECT')) return;
      if (input.tagName === 'SELECT' && !Array.from(input.options).some(function(o) {return o.value === value;})) return;
      input.value = value;
    });
    var stored = form.querySelector('[data-mss-context]');
    var offerTitle = form.querySelector('[data-mss-offer-title]');
    if (offerTitle && context.title) {offerTitle.hidden = false; offerTitle.querySelector('input').value = context.title;}
    if (stored) stored.value = JSON.stringify({product:context.product,variant:context.variant,search:context.search,mpn:context.mpn,displayedEstimateReference:context.estimate,currency:'USD',priceStatus:'Untrusted browser reference; verify supplier price and apply approved policy before quoting.'});
    var emailEstimate = form.querySelector('[data-mss-email-estimate]');
    if (emailEstimate) emailEstimate.value = context.estimate && Number(context.estimate) > 0
      ? '$' + Number(context.estimate).toFixed(2) + ' USD per unit'
      : 'Not displayed — pricing requested';
    var estimateField = form.querySelector('[data-mss-estimate-field]');
    if (estimateField) estimateField.hidden = !(context.estimate && Number(context.estimate) > 0);
    var ref = form.querySelector('[data-mss-estimate-reference]');
    if (context.estimate && ref) {ref.hidden = false; ref.textContent = 'Estimate reference: $' + Number(context.estimate).toFixed(2) + ' USD. This reference is subject to verification; final pricing is confirmed in your quote.';}
  }
  function initProducts() {
    document.querySelectorAll('[data-mss-rfq-product]').forEach(function(section) {
      var form = section.querySelector('.mss-product-quote-form'); if (!form) return;
      var factsTarget = section.querySelector('[data-mss-product-facts]');
      if (factsTarget) {factsTarget.replaceChildren(); factsTarget.hidden = true;}
      form.addEventListener('submit', function() {
        var select = form.querySelector('[name="variant"]');
        if (!select) return;
        var optionText = select.options[select.selectedIndex]?.textContent || '';
        var c = conditionInfo({condition:optionText,title:''});
        if (c) {
          var input = form.querySelector('[name="condition"]') || document.createElement('input');
          input.type = 'hidden'; input.name = 'condition'; input.value = c.label; form.appendChild(input);
        }
      });
    });
  }
  function initFamilyFallbacks() {
    document.querySelectorAll('[data-mss-family-evidence]').forEach(function(holder){
      var figure=familyFigure(holder.dataset.mssFamilyEvidence);
      if(figure)holder.replaceChildren(figure);
    });
  }
  var api = {offeredModelConflict:offeredModelConflict,brandFamilyRules:brandFamilyRules,renderOffer:renderOffer,applyFamilyContext:applyFamilyContext,initFamilyFallbacks:initFamilyFallbacks,familyKey:familyKey,familyFigure:familyFigure,catalogPresence:catalogPresence,nativeQuery:nativeQuery,safeInfoLink:safeInfoLink,renderExternalInfo:renderExternalInfo,normalize:normalize,exactMatch:exactMatch,extractModel:extractModel,accessoryForParent:accessoryForParent,conditionInfo:conditionInfo,estimate:estimate,selectOffers:selectOffers,quoteUrl:quoteUrl,readContext:readContext,lookup:lookup,matchingFacts:matchingFacts};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document !== 'undefined') {
    function init() {initFamilyFallbacks();document.querySelectorAll('[data-mss-search]').forEach(initSearch); prefill(); initProducts();}
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
    document.addEventListener('shopify:section:load',initFamilyFallbacks);
  }
})(typeof window !== 'undefined' ? window : {});
